import { EncMarks, Encoding } from '@mode-vegas/vegas';
import { Field, Model } from '@mode-switch/model';
import { PivotQuery } from '@mode-switch/query';
import { FlamingoTypes } from '@mode/shared/contract-common';

import { makeField } from './field';

type ModeRole = FlamingoTypes.ModeRole;

export function makeMarks(
  model: Model<ModeRole>,
  viewName: string,
  encoding: Encoding,
  fields: Map<string, Field<ModeRole>>,
  encMarks: EncMarks
): PivotQuery.Marks<ModeRole> {
  let marks: PivotQuery.Marks<ModeRole> = {};

  if (encMarks.color.values.length > 0) {
    for (const encField of encMarks.color.values) {
      const field = makeField(model, viewName, encoding, fields, encField);
      marks = { ...marks, color: [...(marks['color'] || []), field] };
    }
  }

  if (encMarks.size.values.length > 0) {
    for (const encField of encMarks.size.values) {
      const field = makeField(model, viewName, encoding, fields, encField);
      marks = { ...marks, size: [...(marks['size'] || []), field] };
    }
  }

  if (encMarks.text.values.length > 0) {
    for (const encField of encMarks.text.values) {
      const field = makeField(model, viewName, encoding, fields, encField);
      marks = { ...marks, text: [...(marks['text'] || []), field] };
    }
  }

  if (encMarks.label.values.length > 0) {
    for (const encField of encMarks.label.values) {
      const field = makeField(model, viewName, encoding, fields, encField);
      marks = { ...marks, label: [...(marks['label'] || []), field] };
    }
  }

  if (encMarks.detail.values.length > 0) {
    for (const encField of encMarks.detail.values) {
      const field = makeField(model, viewName, encoding, fields, encField);
      marks = { ...marks, detail: [...(marks['detail'] || []), field] };
    }
  }

  if (encMarks.tooltip.values.length > 0) {
    for (const encField of encMarks.tooltip.values) {
      const field = makeField(model, viewName, encoding, fields, encField);
      marks = { ...marks, tooltip: [...(marks['tooltip'] || []), field] };
    }
  }

  if (encMarks.angle.values.length > 0) {
    for (const encField of encMarks.angle.values) {
      const field = makeField(model, viewName, encoding, fields, encField);
      marks = { ...marks, angle: [...(marks['angle'] || []), field] };
    }
  }

  if (encMarks.baseline.values.length > 0) {
    for (const encField of encMarks.baseline.values) {
      const field = makeField(model, viewName, encoding, fields, encField);
      marks = { ...marks, baseline: [...(marks['baseline'] || []), field] };
    }
  }
  return marks;
}
